import React from 'react';

export const UpArrow = ({
  color = 'black',
  size = '100',
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20,60 L50,30 L80,60"
        fill="none"
        stroke={color}
        strokeWidth="8"
      />
    </svg>
  );
};
